export enum RepositoryType {
  GRAPH_DB = 'graphdb',
  ONTOP = 'ontop',
  FEDX = 'fedx',
  SYSTEM = 'system',
  OTHER = 'other'
}
